import type { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import type { ThunkDispatch } from 'redux-thunk';
import Logger from '../../utils/Logger';
import session from '../../account/sessionReducer';
import editor from '../../editor/editorReducer';
import onboarding from '../../onboarding/onboardingReducer';
import ui from '../../ui/uiReducer';

const isProd = process.env.NODE_ENV === 'production';

const store = configureStore({
  reducer: {
    editor,
    onboarding,
    ui,
    session,
  },
  devTools: !isProd,
  middleware(getDefaultMiddleware) {
    const middlewares = [
      Logger.reduxMiddleware,
      ...getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }),
    ];

    if (!isProd) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
      const { createLogger } = require('redux-logger');
      middlewares.push(
        createLogger({
          level: 'info',
          collapsed: true,
        }),
      );
    }

    return middlewares;
  },
});

type RootState = ReturnType<typeof store.getState>;
type Store = Omit<typeof store, 'dispatch'> & {
  dispatch: ThunkDispatch<RootState, undefined, AnyAction> &
    Dispatch<AnyAction>;
};

const getReduxStore = (): Store => store;
export default getReduxStore;
